import { PrimaryCategoryKeys } from '@webapp/platform/organization-management/entities/enums/PrimaryCategoryKeys'

const primaryCategoryKey = 'primary-category'

export const primaryCategoryKeys = {
  all: [primaryCategoryKey],
  configList: [primaryCategoryKey, PrimaryCategoryKeys.CONFIG_LIST],
  // Bounded cross-page fetch for select-all; the literal 'all' keeps it
  // apart from the paged list keys while the configList prefix invalidation
  // still covers it.
  configListAll: (
    active?: boolean,
    search?: string,
    legalEntityIds?: number[]
  ) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_LIST,
    'all',
    active,
    search,
    legalEntityIds,
  ],
  configListUnfilteredCount: (active?: boolean) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_LIST,
    'unfiltered-count',
    active,
  ],
  configDetail: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
  ],
  secondaryCategories: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.SECONDARY_CATEGORIES,
  ],
  secondaryCategoriesUnfilteredCount: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.SECONDARY_CATEGORIES,
    'unfiltered-count',
  ],
  secondaryCategoryConfigDetail: (id: number) =>
    [primaryCategoryKey, 'secondary-category-config-detail', id] as const,
  entityReassignmentPreview: (id: number, legalEntityId: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    'entity-reassignment-preview',
    legalEntityId,
  ],
  configUsers: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.CONFIG_USERS,
  ],
}
